<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop" style="text-align:center">To Bruce Hinson, with thanks.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3_ded.vue?5044c1e0